import numbro from "numbro";

export default (number, format = {}) => numbro(number).format(format);
